import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button.js';
import { Create, FileCopySharp, Visibility } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import Modal2 from './ModalUpdate';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 160 },
  { Header: 'Periodo', accessor: 'periodo', width: 140  },
  { Header: 'Incentivo', accessor: 'incentivo', width: 160 },
  { Header: 'Descripción', accessor: 'mecanica' },
  { Header: 'Fecha de corte', accessor: 'fec_corte' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Mecanica(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [model2, setOpen2] = useModal();
  const [notify, showNotify] = useToasty();
  const [mecanicaVentas, setMecanicaVentas] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, field, value) => {
    const index = mecanicaVentas.findIndex((item) => item.id == id);
    mecanicaVentas[index][field] = value;
    setMecanicaVentas([...mecanicaVentas]);
  };
  
  async function loadVentas(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/mecanica-venta', filter);
    setDataLoading(false);
  
    if (response.success) {
      setMecanicaVentas(response.data);
    }
  }
  
  async function updateVentas(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/mecanica-venta', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data);
      loadVentas(valueSearch);
    } else {
      showNotify(response.message, 'error');
      loadVentas(valueSearch);
    }
  }


  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadVentas(valueSearch)}
        />
      ) : undefined}
      {model2.open ? (
        <Modal2 
          model={model2}
          setOpen={setOpen2}
          showNotify={showNotify}
          reload={() => loadVentas(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de mecanica de ventas{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadVentas}
              getValueSearch={(value) => {
                setValueSearch(value);
                // handleFilterChange(value);
              }}
              date
              dateType="month"
              labelDate="periodo"
              dateField="periodo"
            />
            {/* <Button
              color="danger"
              // disabled={isButtonDisabled}
              // onClick={() => {
              //   if (currentPeriod === 202501) {
              //     const currentPeriodDiciembre = 202412;
              //     transferirRegistros(currentPeriodDiciembre, currentPeriod);
              //   }else if(currentPeriod > 202501){
              //     const sourcePeriod = currentPeriod - 1;
              //     transferirRegistros(sourcePeriod, currentPeriod);
              //   }
              // }}
              >
              Inicializar mecanica de ventas
            </Button> */}
            <ReactTable
              excelName="mecanica_ventas"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={mecanicaVentas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen2(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_SHOW}>
                        <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                          <Link to={`${item.id}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/mecanica-venta"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadVentas(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  periodo: item.periodo,
                  incentivo: item.incentivo,
                  mecanica: item.mecanica,
                  fec_corte: item.fec_corte,
                  cobertura: item.cobertura,
                  ItemName: item.ItemName,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
